{
  "app.update.continue": "Pokračovat",
  "app.update.later": "Později",
  "app.update": "Nainstalovali jsme novou verzi aplikace. Pro dokončení instalace je třeba provést refresh aplikace.",
  "base.workingOffline": "Pracujete offline",
  "camera.select.back": "Zadní kamera {{index}}",
  "camera.select.front": "Přední kamera {{index}}",
  "camera.select.generic": "Kamera {{index}}",
  "canceled.text": "Kontaktujte pojišťovnu a nechte si odkaz poslat znovu.",
  "canceled.title": "Platnost Vašeho odkazu vypršela!",
  "claim": {
    "capture": {
      "subject": "celé vozidlo",
      "text": "Vyfoťte <bold>celé vozidlo</bold> ze strany kde se nachází poškození. Ujistěte se, že je na fotce vozidlo celé.",
      "title": "Vyfocení celého vozidla"
    },
    "captureDetail": {
      "buttonPrimary": "Přidat detail",
      "buttonSecondary": "Hotovo",
      "description": "Vyfoťte detail poškození. Doporučujeme udělat více fotografií.",
      "heading": "Vyfocení detailů poškození"
    },
    "markDamage": {
      "button": "Vyfotit detaily",
      "buttonModal": "Pokračovat",
      "clear": "Zrušit označení",
      "backToSelect": "Vybrat jiné foto",
      "description": "Označte prstem na fotografii výše kde se vaše poškození nachází. V případě že máte poškození na více místech, označte jen jedno. Další můžete přidat později.",
      "heading": "Označení poškození",
      "how": "Jak na to",
      "retake": "Vyfotit znovu",
      "subheading": "Jak na to?"
    },
    "overview": {
      "addMoreDamageButton": "Přidat další poškození",
      "continueButton": "Pokračovat",
      "description": "Zde vidíte přehled všech poškození k nahlášení. Vyfocená poškození můžete smazat, nebo přidat další.",
      "emptyPlaceholder": "Zatím nemáte žádné poškození. Přidejte alespoň jedno, abyste mohli pokračovat.",
      "heading": "Přehled poškození",
      "itemButton": "Přidat detail",
      "itemDescription_few": "<span>{{count}}</span> detaily poškození",
      "itemDescription_one": "<span>{{count}}</span> detail poškození",
      "itemDescription_other": "<span>{{count}}</span> detailů poškození",
      "itemTitle": "Poškození #{{index}}"
    },
    "photoDeleteModal": {
      "cancelButton": "Zrušit",
      "confirmButton": "odstranit",
      "description": "Tuto akci už nebude možné vrátit zpět.",
      "heading": "Chcete odstranit <span>Poškození #{{index}}</span> ?",
      "lastMarkerDescription": "Tímto se smaže i hlavní fotografie. <br /><br />Následně můžete přidat nový pohled a označit poškození znovu."
    },
    "photoSelect": {
      "buttonBack": "Zpět",
      "buttonNew": "Vyfotit nové foto",
      "buttonSelect": "Označit zde",
      "description": "Další poškození můžete označit na již pořízené fotografii, nebo můžete fotografii vytvořit novou.",
      "heading": "Vyberte kam chcete označit nové poškození"
    }
  },
  "damage.addMore.primaryActionTitle": "Přidat další poškození",
  "damage.addMore.secondaryActionTitle": "Pokračovat",
  "damage.addMore.text": "Pokud ano, vyfoťte je prosím. Je potřeba vyfotit veškeré poškození na vozidle.",
  "damage.addMore.title": "Máte další poškození?",
  "damage.append.done": "Hotovo",
  "damage.append.photos": "Přidat poškození",
  "damage.capture.secondaryActionTitle": "Jít zpět",
  "damage.capture.text": "Vyfoťte prosím detail poškození. Fotografie by měla být ostrá a dobře osvětlená.",
  "damage.capture.title": "Vyfoťte detail poškození",
  "damage.intro.primaryActionTitle": "Vyfotit poškození",
  "damage.intro.secondaryActionTitle": "Nemám poškození",
  "damage.intro.secondaryActionTitleAlt": "Pokračovat",
  "damage.PersonalVehicle.intro.text": "Pokud máte na vozidle jakékoliv poškození, vyfoťte je, prosím.",
  "damage.Motorcycle.intro.text": "Pokud máte na vozidle jakékoliv poškození, vyfoťte je, prosím.",
  "damage.AgriculturalMachine.intro.text": "Pokud máte na stroji jakékoliv poškození, vyfoťte je, prosím.",
  "damage.intro.title": "Poškození",
  "damage.select.primaryActionTitle": "Uložit",
  "damage.select.secondaryActionTitle": "Znovu vyfotit",
  "damage.select.text": "Jedním stiskem <bold>přidáte výběr</bold>.<br/>Dvojitým stisknutím <bold>zrušíte výběr</bold>.<br/>Výběr můžete upřesnit tahem.",
  "damage.select.title": "Označte, kde se poškození nachází",
  "damage.select.warningModal.text": "Nevybrali jste kde se poškození nachází. Jste si jisti, že chcete pokračovat?",
  "device.storage.quotaExceeded": "Prosíme uvolněte místo na disku. Aplikace může pokračovat jen v online režimu.",
  "documents.intro.button.continue": "Jdeme na to",
  "documents.intro.button.later": "Nemám dokumenty u sebe",
  "documents.intro.button.skipAll": "Přeskočit",
  "documents.intro.modal.button": "Rozumím",
  "documents.intro.modal.heading": "Povinné dokumenty",
  "documents.intro.modal.text": "Pro dokument si dojděte, k focení se můžete vrátit za chvíli. Bez vyfoceného povinného dokladu nemůžete prohlídku vozidla dokončit a fotky odeslat.",
  "documents.intro.text": "Vyfoťte prosím následující dokumenty:",
  "documents.intro.title": "Dokumenty",
  "documents.type.driversLicence": "Řidičský průkaz",
  "documents.type.invoice": "Faktura",
  "documents.type.otherDocument": "Jiný dokument",
  "documents.type.proofOfInsurance": "Zelená karta",
  "documents.type.roadworthinessCertificate": "Velký technický průkaz",
  "documents.type.transferProtocol": "Předávací protokol",
  "documents.type.identityCardFront": "Občanský průkaz - přední strana",
  "documents.type.identityCardBack": "Občanský průkaz - zadní strana",
  "documents.type.vehicleCertificate": "Malý technický průkaz",
  "documents.type.acceptanceProtocol": "Předávací protokol",
  "documents.type.driversLicense": "Řidičský průkaz",
  "documents.type.accidentStatement": "Záznam o dopravní nehodě",
  "error.incompatiblePhone.button": "Jít zpět",
  "error.incompatiblePhone.heading": "Něco se pokazilo",
  "error.notFound.heading": "Neplatný odkaz",
  "error.notFound.text": "Pro vstup do aplikace použijte unikátní odkaz, který vám vygenerovala vaše pojišťovna.",
  "error.staleVersion.button": "Načíst znovu",
  "error.staleVersion.text": "Aplikace byla aktualizována. Je potřeba ji načíst znovu.",
  "error.incompatiblePhone.text": "Mrzí nás to, ale aplikace bohužel s Vaším telefonem nespolupracuje. Kontaktujte pojišťovnu ohledně dalšího postupu.",
  "extra.equipment.intro.primaryActionTitle": "Vyfotit výbavu",
  "extra.equipment.intro.secondaryActionTitle": "Nemám nic extra",
  "extra.equipment.PersonalVehicle.intro.text": "Pokud máte na vozidle jakoukoliv nestandardní, dodatečně zabudovanou výbavu, prosíme, vyfoťte ji. Může se jednat například o sound systémy, tuning, sady disků z lehkých slitin apod.",
  "extra.equipment.Motorcycle.intro.text": "Pokud máte na vozidle jakoukoliv nestandartní, dodatečně zabudovanou výbavu, prosím, vyfoťte ji. Může se jednat o kufry, slidery, brašny, tank vak, držáky na navigaci, navigaci apod.",
  "extra.equipment.AgriculturalMachine.intro.text": "Pokud máte na stroji jakoukoliv nestandardní, dodatečně zabudovanou výbavu, prosíme, vyfoťte ji.",
  "extra.equipment.intro.title": "Nestandardní výbava",
  "extra.equipment.select.hasPhotos_one": "Máte vyfocenou <span>{{count}}</span> fotografii extra výbavy. Chcete přidat další fotky?",
  "extra.equipment.select.hasPhotos_few": "Máte vyfocené <span>{{count}}</span> fotografie extra výbavy. Chcete přidat další fotky?",
  "extra.equipment.select.hasPhotos_other": "Máte vyfoceno <span>{{count}}</span> fotografií extra výbavy. Chcete přidat další fotky?",
  "extra.equipment.select.addMore": "Přidat další",
  "finished.close": "Zavřít",
  "finished.sent": "Fotografie jsou odeslané.",
  "finished.thankyou": "Děkujeme!",
  "generali.caseNumber.caseIdLabel": "Číslo smlouvy - pouze vznik podpisem",
  "generali.caseNumber.caseIdPlaceholder": "Číslo smlouvy",
  "generali.caseNumber.caseIdSecondaryLabel": "Povinný údaj",
  "generali.caseNumber.secondaryCaseIdLabel": "Získatelské číslo",
  "generali.caseNumber.secondaryCaseIdPlaceholder": "Získatelské číslo",
  "generali.caseNumber.submit.error": "Něco se pokazilo při úkládání údajů. Zkuste to prosím později.",
  "generali.caseNumber.submit.saved": "Data úspěšně uložena.",
  "generali.caseNumber.submit.saving": "Ukládám data.",
  "generali.caseNumber.title": "Zadejte prosím číslo Vaší pojistné smlouvy.",
  "generali.caseNumber.validations.length": "Prosím zadejte přesně 10 cifer.",
  "generali.caseNumber.validations.required": "Toto pole je povinné.",
  "generali.caseNumber.validations.modulo": "Nesedí kontrolní součet modulo 10.",
  "generali.caseNumber.validations.ninthDigit": "Na 9. pozici nesmí být číslice {{ val }}",
  "generali.caseNumber.validations.number": "Prosím zadejte pouze čísla.",
  "generali.caseNumber.validations.thirdDigit": "Na 3. pozici musí být číslice {{ val }}",
  "guide.blurry.text": "Fotografie je rozmazaná. Vyfoťte ji prosím znovu.",
  "guide.onlyLandscape.title": "Fotografie je na výšku",
  "guide.onlyLandscape.text": "Fotografie je na výšku, ale potřebujeme ji na šířku. Vyfoťte ji prosím znovu na šířku.",
  "guide.blurry.title": "Fotografie je rozmazaná",
  "guide.blackAndWhite.text": "Fotografie je černobílá. Vyfoťte ji prosím znovu barevně.",
  "guide.blackAndWhite.title": "Černobílá fotografie",
  "guide.cameraTimeout.retry": "Zkusit znovu",
  "guide.cameraTimeout.text": "Nepodařilo se získat práva ke kameře. Povolte, prosím, kameru v nastavení a zkuste to znovu.",
  "guide.confirm.agree": "SOUHLASÍ",
  "guide.confirm.tookAnother": "Očekávaný pohled",
  "guide.confirm.youTookPhoto": "Vyfotili jste",
  "guide.confirmDisabledModel.text": "Zkontrolujte si prosím, že chcete tuto fotografii použít.",
  "guide.confirmDisabledModel.title": "Je fotografie v pořádku?",
  "guide.error.retry": "Zkusit znovu",
  "guide.error.text": "Bohužel něco se pokazilo. Zkuste vypnout a zapnout aplikaci.",
  "guide.fromScreen.text": "Fotografie je z obrazovky. Vyfoťte ji prosím znovu.",
  "guide.fromScreen.title": "Fotografie je z obrazovky",
  "guide.licensePlate.text": "Vozidlu chybí poznávací značka. Umístěte ji na vozidlo a vyfoťte ho znovu.",
  "guide.licensePlate.title": "Chybí poznávací značka",
  "guide.notWholeExterior": "Na fotografii není celé vozidlo. Zkontrolujte si prosím, že při focení není žádná část vozidla mimo záběr.",
  "guide.notWholeOther": "Na fotografii není vidět kompletní",
  "guide.documentWrongImage": "Na fotografii se nenachází požadovaný doklad, nebo tento doklad není vyfocen celý.",
  "guide.documentWrongImageTitle": "Špatně vyfocený doklad",
  "guide.otherPhotoExterior": "Zkontrolujte si prosím, že v záběru nejsou žádná další vozidla nebo fotografie není rozmazaná.",
  "guide.otherPhotoOther": "Zkontrolujte si prosím, že v záběru nejsou žádné další části vozidla nebo fotografie není rozmazaná.",
  "guide.permissions.denied.close": "Zavřít",
  "guide.permissions.denied.how": "Jak udělit oprávnění?",
  "guide.permissions.denied.text": "Bohužel nemáme povolený přístup ke kameře. Povolte, prosím, kameru v nastavení a zkuste to znovu.<br/><br/><bold>Bez oprávnění ke kameře nebude možné prohlídku vozidla dokončit a fotografie odeslat.</bold>",
  "guide.permissions.denied.title": "Chybí oprávnění",
  "guide.portraitPhoto.text": "Fotografii jste vyfotili na výšku, vyfoťte ji prosím znovu na šířku.",
  "guide.portraitPhoto.title": "Špatné natočení!",
  "guide.skip": "Přeskočit",
  "guide.step": "Krok",
  "guide.takePhoto": "Vyfotit",
  "guide.uploadPhoto": "Nahrát",
  "guide.visibility.text": "Fotografie je pořízená za zhoršených podmínek viditelnosti. Vyfoťte ji prosím znovu.",
  "guide.visibility.title": "Špatná viditelnost",
  "guide.winter.text": "Vozidlo je zasněžené nebo pokryté námrazou. Prosíme, odstraňte sníh nebo námrazu a vyfoťte ho znovu.",
  "guide.winter.title": "Zasněžené vozidlo",
  "guide.notReal.text": "Vozidlo není vyfoceno v reálném prostředí. Prosím, vyfoťte reálné vozidlo.",
  "guide.notReal.title": "Nereálné vozidlo",
  "guide.farDistance.text": "Vozidlo je vyfoceno z velké vzdálenosti. Prosím, vyfoťte vozidlo z větší blízkosti.",
  "guide.farDistance.title": "Vzdálené vozidlo",
  "guide.openDoorOrWindow.text": "Na vozidle jsou otevřené dveře nebo okno - prosíme o zavření.",
  "guide.openDoorOrWindow.title": "Otevřené dveře nebo okno",
  "guide.wrongphoto.again": "Vyfotit znovu",
  "guide.wrongphoto.apply": "Použít",
  "guide.wrongphoto.failed": "Fotografie není v pořádku",
  "guide.wrongphoto.invalidVinTitle": "Nečitelný VIN",
  "guide.wrongphoto.invalidWindscreenTitle": "Špatně vyfocené čelní sklo",
  "guide.wrongphoto.invalidOdometerTitle": "Špatně vyfocený tachometr",
  "guide.wrongphoto.invalidVin": "Na fotografii není kompletní VIN nebo není čitelné. Zkontrolujte prosím, že VIN není částečně zakryté, pokryté prachem, vodou nebo odleskem slunce či blesku nebo není v záběru jiný štítek.",
  "guide.wrongphoto.invalidWindscreen": "Na fotografii není kompletní čelní sklo nebo je foceno ze špatného úhlu či velké vzdálenosti.",
  "guide.wrongphoto.invalidOdometer": "Na fotografii není kompletní tachometr nebo není čitelný.",
  "guide.wrongphoto.windscreenIsNotFrontSide": "Na fotografii je vozidlo zepředu. Prosíme o větší detail čelního skla.",
  "guide.wrongphoto.wrongAngleTitle": "Špatný úhel",
  "guide.wrongphoto.wrongAngle": "Vozidlo není vyfoceno ze správného úhlu či vhodné perspektivy. Zkuste změnit pozici focení a vyfoťte prosím vozidlo znovu.",
  "guide.wrongphoto.alreadyPhotographedTitle": "Špatný pohled",
  "guide.wrongphoto.alreadyPhotographed": "Tento pohled už máte vyfocený. Vyfoťte prosím pohled, který právě požadujeme.",
  "guide.youAreTakingPhoto": "Fotíte:",
  "intro.camera.PersonalVehicle.text": "Za okamžik Vás požádáme o přístup ke <bold>kameře</bold> a <bold>mikrofonu</bold>, abyste mohli vyfotit Vaše vozidlo.",
  "intro.camera.Motorcycle.text": "Za okamžik Vás požádáme o přístup ke <bold>kameře</bold> a <bold>mikrofonu</bold>, abyste mohli vyfotit Vaše vozidlo.",
  "intro.camera.AgriculturalMachine.text": "Za okamžik Vás požádáme o přístup ke <bold>kameře</bold> a <bold>mikrofonu</bold>, abyste mohli vyfotit Váš stroj.",
  "intro.camera.title": "Můžeme fotit, prosím?",
  "intro.carsaround.PersonalVehicle.text": "Ujistěte se, že v okolí Vašeho vozidla nejsou žádná další vozidla.",
  "intro.carsaround.Motorcycle.text": "Ujistěte se, že v okolí Vašeho vozidla nejsou žádná další vozidla.",
  "intro.carsaround.AgriculturalMachine.text": "Ujistěte se, že v okolí Vašeho stroje nejsou žádné další stroje nebo zařízení.",
  "intro.carsaround.PersonalVehicle.title": "Pozor na auta",
  "intro.carsaround.Motorcycle.title": "Pozor na auta",
  "intro.carsaround.AgriculturalMachine.title": "Pozor na stroje",
  "intro.distance.PersonalVehicle.text": "Ujistěte se, že kolem Vašeho vozidla máte alespoň 3 m volného místa.",
  "intro.distance.Motorcycle.text": "Ujistěte se, že kolem Vašeho vozidla máte alespoň 3 m volného místa.",
  "intro.distance.AgriculturalMachine.text": "Ujistěte se, že kolem Vašeho stroje máte alespoň 3 m volného místa.",
  "intro.distance.title": "Udělejte si místo",
  "intro.expectedValues.dto": "Najeté kilometry",
  "intro.expectedValues.model": "Značka a obchodní značení",
  "intro.expectedValues.spz": "Registrační značka",
  "intro.expectedValues.PersonalVehicle.subtitle": "Vaše vozidlo",
  "intro.expectedValues.Motorcycle.subtitle": "Vaše vozidlo",
  "intro.expectedValues.AgriculturalMachine.subtitle": "Váš stroj",
  "intro.expectedValues.PersonalVehicle.title": "Prohlídka vozidla",
  "intro.expectedValues.Motorcycle.title": "Prohlídka vozidla",
  "intro.expectedValues.AgriculturalMachine.title": "Prohlídka stroje",
  "intro.expectedValues.vin": "VIN",
  "intro.gps.text": "Za okamžik Vás požádáme o přístup k <bold>poloze</bold>, abychom si ověřili, že jsou fotografie foceny na stejném místě.",
  "intro.gps.title": "Řeknete nám, kde jste? ",
  "intro.requirements.PersonalVehicle.text": "<li>alespoň 10 minut času</li><li>dobrou viditelnost (fotíte za denního světla)</li><li>čisté a suché vozidlo (bez sněhu, námrazy, bláta, špíny, atd.)</li>",
  "intro.requirements.Motorcycle.text": "<li>alespoň 10 minut času</li><li>dobrou viditelnost (fotíte za denního světla)</li><li>čisté a suché vozidlo (bez sněhu, námrazy, bláta, špíny, atd.)</li>",
  "intro.requirements.AgriculturalMachine.text": "<li>alespoň 10 minut času</li><li>dobrou viditelnost (fotíte za denního světla)</li><li>čistý stroj (bez sněhu, námrazy, bláta, špíny, atd.)</li>",
  "intro.requirements.title": "Ujistěte se, že máte",
  "intro.wait.slowInternet": "Vaše připojení k internetu není stabilní. Načtení aplikace může trvat dlouhou dobu.",
  "intro.wait.text": "Aplikace se načítá, což může trvat až <bold>1 minutu</bold>, prosíme počkejte.",
  "intro.wait.title": "Načítáme aplikaci<br />Dejte nám prosím chvilku…",
  "intro.welcome.PersonalVehicle.text": "Vítejte v aplikaci na rychlé a snadné vytvoření fotodokumentace k Vašemu vozidlu. Stačí sledovat průvodce.",
  "intro.welcome.Motorcycle.text": "Vítejte v aplikaci na rychlé a snadné vytvoření fotodokumentace k Vašemu vozidlu. Stačí sledovat průvodce.",
  "intro.welcome.AgriculturalMachine.text": "Vítejte v aplikaci na rychlé a snadné vytvoření fotodokumentace k Vašemu stroji. Stačí sledovat průvodce.",
  "intro.welcome.PersonalVehicle.title": "Pojďme vyfotit Vaše vozidlo!",
  "intro.welcome.Motorcycle.title": "Pojďme vyfotit Vaše vozidlo!",
  "intro.welcome.AgriculturalMachine.title": "Pojďme vyfotit Váš stroj!",
  "overview.button.continueTakingPhotos": "Pokračovat ve focení",
  "overview.button.finishSession": "Odeslat",
  "overview.button.retryUpload": "Nahrát znovu",
  "overview.button.uploadingPhotos": "Nahráváme...",
  "overview.missingSteps.button": "Pokračovat ve focení",
  "overview.missingSteps.text": "Vypadá to, že nemáme některé fotografie, které jsou potřeba k dokončení. Prosím zkontrolujte, že všechny kroky byly dokončeny.",
  "overview.needsInternet": "Je vyžadováno připojení k internetu.",
  "overview.photo_few": "{{count}} fotky",
  "overview.photo_one": "{{count}} fotka",
  "overview.photo_other": "{{count}} fotek",
  "overview.video_few": "{{count}} videa",
  "overview.video_one": "{{count}} video",
  "overview.video_other": "{{count}} videí",
  "overview.photosFailedToUpload.button": "Pokusit se nahrát znovu",
  "overview.photosFailedToUpload.text": "Některé fotografie se nepodařilo nahrát. Zkuste to prosím znovu.",
  "overview.videosFailedToUpload.text": "Některé videa se nepodařilo nahrát. Zkuste to prosím znovu.",
  "overview.slowInternet": "Vaše připojení k internetu je pomalé. Fotografie mohou mít problémy s nahráváním.",
  "overview.uploading": "Fotografie se nahrávají. Počkejte prosím než se nahrají všechny.",
  "permissions.reset.guide.back": "Zpět na focení",
  "permissions.reset.guide.step.four": "<primary>Krok 4:</primary> Obnovte okno prohlížeče aby se změny projevily.",
  "permissions.reset.guide.step.one": "<primary>Krok 1:</primary> Klikněte na ikonku <bold>Nastavení</bold> v levé části adresního řádku prohlížeče.",
  "permissions.reset.guide.step.three": "<primary>Krok 3:</primary> Povolte oprávnění pro <bold>kameru</bold> a <bold>polohu</bold> nebo klikněte na <bold>Resetovat oprávnění</bold>.",
  "permissions.reset.guide.step.two": "<primary>Krok 2:</primary> Klikněte na řádek s názvem <bold>Oprávnění</bold>.",
  "permissions.reset.guide.title": "Postup udělení / resetování oprávnění",
  "photo.delete": "Smazat fotku",
  "photo.enlarge": "Zvětšit fotku",
  "photo.shrink": "Zmenšit fotku",
  "phototype.PersonalVehicle.category.carview": "Pohledy na vozidlo",
  "phototype.Motorcycle.category.carview": "Pohledy na vozidlo",
  "phototype.AgriculturalMachine.category.carview": "Pohledy na stroj",
  "phototype.category.claim": "Poškození",
  "phototype.category.damage": "Poškození",
  "phototype.category.documents": "Dokumenty",
  "phototype.category.exterior": "Exteriér",
  "phototype.category.extra.equipment": "Nestandardní výbava",
  "phototype.category.interior": "Interiér",
  "phototype.claim.name": "Poškození",
  "phototype.damage.name": "Poškození",
  "phototype.dash.guide": "Ujistěte se, že palubní deska je vyfocená celá od volantu po schránku palubní desky na straně spolujezdce, a to včetně autorádia, navigace a ovládacích prvků klimatizace. Nejlépe se fotí ze zadního sedadla.",
  "phototype.dash.name": "Palubní deska",
  "phototype.extra.equipment.name": "Nestandardní výbava",
  "phototype.PersonalVehicle.frontLeftSide.guide": "Strana řidiče. Ujistěte se, že máte na fotce celé vozidlo a registrační značku.",
  "phototype.Motorcycle.frontLeftSide.guide": "Ujistěte se, že máte na fotce celé vozidlo.",
  "phototype.AgriculturalMachine.frontLeftSide.guide": "Ujistěte se, že máte na fotce celý stroj a registrační značku.",
  "phototype.frontLeftSide.name": "Levá přední strana",
  "phototype.PersonalVehicle.frontRightSide.guide": "Strana spolujezdce. Ujistěte se, že máte na fotce celé vozidlo a registrační značku.",
  "phototype.Motorcycle.frontRightSide.guide": "Ujistěte se, že máte na fotce celé vozidlo.",
  "phototype.AgriculturalMachine.frontRightSide.guide": "Ujistěte se, že máte na fotce celý stroj a registrační značku.",
  "phototype.frontRightSide.name": "Pravá přední strana",
  "phototype.PersonalVehicle.frontSide.guide": "Vozidlo foťte tak, aby byla viditelná celá přední část vozidla a registrační značka.",
  "phototype.Motorcycle.frontSide.guide": "Vozidlo foťte tak, aby byla viditelná celá přední část vozidla.",
  "phototype.AgriculturalMachine.frontSide.guide": "Stroj foťte tak, aby byla viditelná celá přední část stroje a registrační značka.",
  "phototype.frontSide.name": "Přední strana",
  "phototype.invoice.guide": "Přední strana faktury. Ujistěte se, že je na fotce doklad celý a že informace jsou čitelné.",
  "phototype.invoice.name": "Faktura",
  "phototype.PersonalVehicle.leftSide.guide": "Strana řidiče. Vozidlo foťte tak, aby byl viditelný celý bok vozidla.",
  "phototype.Motorcycle.leftSide.guide": "Vozidlo foťte tak, aby byl viditelný celý bok vozidla.",
  "phototype.AgriculturalMachine.leftSide.guide": "Stroj foťte tak, aby byl viditelný celý bok stroje.",
  "phototype.leftSide.name": "Levá strana",
  "phototype.motor.guide": "Ujistěte se, že na fotce máte celý motor i registrační značku.",
  "phototype.motor.name": "Motor a registrační značka",
  "phototype.odometer.guide": "Vyfoťte tachometr ze sedadla řidiče. Ujistěte se, že je na tachometru vidět celkový počet kilometrů.",
  "phototype.odometer.name": "Tachometr",
  "phototype.cockpit.name": "Kokpit jezdce",
  "phototype.cockpit.guide": "Vyfoťte kokpit jezdce na motorce z vrchu.",
  "phototype.keys.name": "Klíče od vozidla",
  "phototype.keys.guide": "Vyfoťte oba klíče od vozidla, ujistěte se, že jsou oba celé v záběru.",
  "phototype.otherdocument.guide": "Zde můžete zadat jakýkoliv jiný typ dokumentu. Ujistěte se, že je na fotografii vidět celý dokument a že jsou informace čitelné.",
  "phototype.otherdocument.name": "Jiný dokument",
  "phototype.PersonalVehicle.rearLeftSide.guide": "Strana řidiče. Ujistěte se, že máte na fotce celé vozidlo a registrační značku.",
  "phototype.Motorcycle.rearLeftSide.guide": "Ujistěte se, že máte na fotce celé vozidlo a registrační značku.",
  "phototype.AgriculturalMachine.rearLeftSide.guide": "Ujistěte se, že máte na fotce celý stroj.",
  "phototype.rearLeftSide.name": "Levá zadní strana",
  "phototype.PersonalVehicle.rearRightSide.guide": "Strana spolujezdce. Ujistěte se, že máte na fotce celé vozidlo a registrační značku.",
  "phototype.Motorcycle.rearRightSide.guide": "Ujistěte se, že máte na fotce celé vozidlo a registrační značku.",
  "phototype.AgriculturalMachine.rearRightSide.guide": "Ujistěte se, že máte na fotce celý stroj.",
  "phototype.rearRightSide.name": "Pravá zadní strana",
  "phototype.PersonalVehicle.rearSide.guide": "Vozidlo foťte tak, aby byla viditelná celá zadní část vozidla a registrační značka.",
  "phototype.Motorcycle.rearSide.guide": "Vozidlo foťte tak, aby byla viditelná celá zadní část vozidla a registrační značka.",
  "phototype.AgriculturalMachine.rearSide.guide": "Stroj foťte tak, aby byla viditelná celá zadní část stroje.",
  "phototype.rearSide.name": "Zadní strana",
  "phototype.registrationback.guide": "Zadní strana malého technického průkazu. Ujistěte se, že je na fotce průkaz celý a že informace jsou čitelné.",
  "phototype.registrationback.name": "Osvědčení o registraci vozidla - zadní strana",
  "phototype.registrationfront.guide": "Přední strana malého technického průkazu. Ujistěte se, že je na fotce průkaz celý a že informace jsou čitelné.",
  "phototype.registrationfront.name": "Osvědčení o registraci vozidla - přední strana",
  "phototype.PersonalVehicle.rightSide.guide": "Strana spolujezdce. Vozidlo foťte tak, aby byl viditelný celý bok vozidla.",
  "phototype.Motorcycle.rightSide.guide": "Vozidlo foťte tak, aby byl viditelný celý bok vozidla.",
  "phototype.AgriculturalMachine.rightSide.guide": "Stroj foťte tak, aby byl viditelný celý bok stroje.",
  "phototype.rightSide.name": "Pravá strana",
  "phototype.roadworthinessback.guide": "Zadní strana velkého technického průkazu. Ujistěte se, že je na fotce průkaz celý a že informace jsou čitelné.",
  "phototype.roadworthinessback.name": "Velký technický průkaz - zadní strana",
  "phototype.roadworthinessfront.guide": "Přední strana velkého technického průkazu. Ujistěte se, že je na fotce průkaz celý a že informace jsou čitelné.",
  "phototype.roadworthinessfront.name": "Velký technický průkaz - přední strana",
  "phototype.transferprotocol.guide": "Přední strana předávacího protokolu. Ujistěte se, že je na fotce doklad celý a že informace jsou čitelné.",
  "phototype.transferprotocol.name": "Předávací protokol",
  "phototype.identityCardFront.guide": "Přední strana občanského průkazu. Ujistěte se, že je na fotce průkaz celý a že informace jsou čitelné.",
  "phototype.identityCardBack.guide": "Zadní strana občanského průkazu. Ujistěte se, že je na fotce průkaz celý a že informace jsou čitelné.",
  "phototype.identityCardFront.name": "Občanský průkaz - přední strana",
  "phototype.identityCardBack.name": "Občanský průkaz - zadní strana",
  "phototype.accidentStatement.guide": "Přední strana záznam o dopravní nehodě. Ujistěte se, že je na fotce záznam o nehodě celý a informace jsou čitelné.",
  "phototype.accidentStatementFront.name": "Záznam o dopravní nehodě",
  "phototype.driversLicenseFront.guide": "Přední strana řidičského průkazu. Ujistěte se, že je na fotce průkaz celý a že informace jsou čitelné.",
  "phototype.driversLicenseBack.guide": "Zadní strana řidičského průkazu. Ujistěte se, že je na fotce průkaz celý a že informace jsou čitelné.",
  "phototype.driversLicenseFront.name": "Řidičský průkaz - přední strana",
  "phototype.driversLicenseBack.name": "Řidičský průkaz - zadní strana",
  "phototype.PersonalVehicle.vin.guide": "Vyfoťte VIN vozidla. Najdete ho na čelním skle, v rámu dveří řidiče, pod sedačkou řidiče nebo v motorovém prostoru vozidla.",
  "phototype.Motorcycle.vin.guide": "Vyfoťte VIN vozidla. Najdete ho například na hlavní rámové trubce, na štítku výrobce nebo na motoru.",
  "phototype.AgriculturalMachine.vin.guide": "Vyfoťte VIN stroje. Najdete ho například na výrobním štítku, na rámu nebo v motorovém prostoru stroje.",
  "phototype.vin.name": "VIN vozidla",
  "phototype.PersonalVehicle.vin.name": "VIN vozidla",
  "phototype.Motorcycle.vin.name": "VIN vozidla",
  "phototype.AgriculturalMachine.vin.name": "VIN stroje",
  "phototype.PersonalVehicle.windscreen.guide": "Vyfoťte čelní sklo zvenku, ujistěte se, že je celé v záběru.",
  "phototype.Motorcycle.windscreen.guide": "Vyfoťte plexi štít zvenku, ujistěte se, že je celý v záběru.",
  "phototype.AgriculturalMachine.windscreen.guide": "Vyfoťte čelní sklo kabiny zvenku, ujistěte se, že je celé v záběru.",
  "phototype.PersonalVehicle.windscreen.name": "Čelní sklo",
  "phototype.Motorcycle.windscreen.name": "Plexi štít",
  "phototype.AgriculturalMachine.windscreen.name": "Čelní sklo kabiny",
  "phototype.PersonalVehicle.windscreenFromInside.guide": "Vyfoťte čelní sklo zevnitř vozidla, ujistěte se, že je celé v záběru.",
  "phototype.Motorcycle.windscreenFromInside.guide": "Vyfoťte čelní sklo zevnitř vozidla, ujistěte se, že je celé v záběru.",
  "phototype.AgriculturalMachine.windscreenFromInside.guide": "Vyfoťte čelní sklo kabiny zevnitř, ujistěte se, že je celé v záběru.",
  "phototype.PersonalVehicle.windscreenFromInside.name": "Čelní sklo zevnitř",
  "phototype.Motorcycle.windscreenFromInside.name": "Plexi štít zevnitř",
  "phototype.AgriculturalMachine.windscreenFromInside.name": "Čelní sklo kabiny zevnitř",
  "phototype.windscreenDriver.name": "Čelní sklo, ze strany řidiče",
  "phototype.windscreenDriver.guide": "Postavte se k přednímu kolu na straně řidiče a vyfoťte celé čelní sklo tak, jak je znázorněno na obrázku.",
  "phototype.windscreenPassenger.name": "Čelní sklo, ze strany spolujezdce",
  "phototype.windscreenPassenger.guide": "Postavte se k přednímu kolu na straně spolujezdce a vyfoťte celé čelní sklo tak, jak je znázorněno na obrázku.",
  "wrongSessionType.text": "Kontaktujte nás prosím ohledně dalšího postupu.",
  "wrongSessionType.title": "K focení nelze přistoupit z prohlížeče",
  "phototype.motorVideo.name": "Video motoru",
  "phototype.motorVideo.guide": "Natočte, prosím, krátké video odkrytého motorového prostoru v nastartovaném stavu, tak aby byl slyšet zvuk motoru.",
  "phototype.dashVideo.name": "Video palubní desky",
  "phototype.dashVideo.guide": "Natočte, prosím, krátké video palubní desky.",
  "phototype.odometerVideo.name": "Video tachometru",
  "phototype.odometerVideo.guide": "Natočte, prosím, krátké video prostoru tachometru, tak aby byl vidět nájezd a bez zařazené rychlosti protočte motor do otáček.",
  "video.guide.confirmVideo.title": "Je video v pořádku?",
  "video.guide.confirmVideo.text": "Zkontrolujte si prosím, že video není rozmazané a že je na něm vidět celý požadovaný pohled.",
  "video.guide.youAreTakingVideo": "Točíte:",
  "video.guide.captureAgain": "Natočit znovu",
  "permissionsGuide": {
    "sectionTop": {
      "title": "POTŘEBUJEME OPRÁVNĚNÍ",
      "text": "Bohužel nemáme povolený přístup k následujícím oprávněním:",
      "text2": "Přístup je nutný pro dokončení fotoprohlídky.",
      "allGranted": "Vše je povoleno.",
      "cameraPermission": "Kamera",
      "locationPermission": "Lokace"
    },
    "sectionBot": {
      "title": "JAK UDĚLIT OPRÁVNĚNÍ?",
      "doneBtn": "HOTOVO"
    },
    "chrome": {
      "name": "Chrome",
      "steps": {
        "1": "Klikněte na <b>tři tečky</b> v pravém horním rohu prohlížeče Chrome",
        "2": "Klikněte na <b>Nastavení</b> a dále na <b>Nastavení webu</b>",
        "3": "<b>Povolte</b> potřebná oprávnění. Pro polohu zvolte <b>Přesnou polohu</b>",
        "4": "V případě, že je přístup blokován systémově, je potřeba vše povolit v <b>Nastavení Android</b>"
      }
    },
    "firefox": {
      "name": "Firefox",
      "steps": {
        "1": "Klikněte na <b>tři tečky</b> v pravém horním rohu prohlížeče Firefox",
        "2": "Klikněte na <b>Nastavení</b> a dále na <b>Nastavení serveru</b>",
        "3": "<b>Povolte</b> potřebná oprávnění. Pro polohu zvolte <b>Přesnou polohu</b>",
        "4": "V případě, že je přístup blokován systémově, je potřeba vše povolit v <b>Nastavení telefonu</b>"
      }
    },
    "samsungInternet": {
      "name": "Samsung Internet",
      "steps": {
        "1": "Klikněte na <b>Menu</b> v pravém dolním rohu prohlížeče Samsung Internet ",
        "2": "Klikněte na <b>Nastavení</b>, dále na <b>Weby a stahování</b> a <b>Oprávnění k webu</b>",
        "3": "<b>Povolte</b> potřebná oprávnění. Pro polohu zvolte <b>Přesnou polohu</b>",
        "4": "V případě, že je přístup blokován systémově, je potřeba vše povolit v <b>Nastavení telefonu</b>"
      }
    },
    "safari": {
      "name": "Safari",
      "steps": {
        "1": "Klikněte na ikonu <b>Nastavení stránky</b> na adresním řádku prohlížeče Safari",
        "2": "Dole v Menu povolte příslušná oprávnění",
        "3": "<b>Obnovte</b> webovou stránku a pokračujte"
      }
    },
    "other": {
      "name": "Ostatní",
      "steps": {
        "1": "V <b>Nastavení</b> prohlížeče povolte potřebná oprávnění a obnovte webovou stránku"
      }
    }
  },
  "consent": {
    "title": "Vítejte!",
    "text": "<p>Vítejte v aplikaci na rychlé a snadné vytvoření fotodokumentace k Vašemu vozidlu, jak jsme si spolu ujednali ve smlouvě.</p><p>Provozujeme ji pomocí aplikace InstaCover AI, díky které je to jednoduché.</p>",
    "linkUrl": "",
    "termsUrl": "",
    "privacyNoticeUrl": "",
    "checkboxes": {
      "termsAndPrivacy": "Souhlasím s podmínkami použití a se <privacy>zpracováním osobních údajů</privacy>."
    },
    "closingText": ""
  },
  "unsupported": {
    "desktopTitle": "Otevřete odkaz na mobilním zařízení.",
    "desktopText": "V průběhu focení budeme potřebovat přístup k vašemu fotoaparátu.<br/><br/>Z počítače to bohužel nejde.<br/><br/>Otevřete odkaz na mobilním zařízení, nejlépe v prohlížeči <bold>Chrome</bold> nebo <bold>Safari</bold>.",
    "browserTitle": "Otevřete odkaz v jiném prohlížeči.",
    "browserText": "Focení v tomto prohlížeči nemusí fungovat správně.<br/><br/>Otevřete prosím odkaz v <bold>Chrome</bold> nebo <bold>Safari</bold> a pokračujte ve focení.",
    "copyLink": "Zkopírovat odkaz",
    "continue": "Pokračovat"
  }
}
